function updateCartAtrributeStateSelected() {
    let selected = getCookie('stateSelected');
    if (selected == "") return;

    // Send request to update cart attribute
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            attributes: {
                state_selected: stateSelected === 'VIC' ? 'VIC' : 'DEFAULT'
            }
        })
    })
        .then(response => response.json())
        .then(data => {
            console.log('Cart attributes updated:', data);
        })
        .catch(error => {
            console.error('Error updating cart attributes:', error);
        })
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

updateCartAtrributeStateSelected();